<template>
    <v-select
        class="pad-visa-selector"
        v-model="selected"
        :items="visas"
        label="Visa"
        hide-details
        single-line
        solo-inverted
        flat />
</template>

<script>
export default {
    name: 'pad-visa-selector',
    props: {
        value: { type: String }
    },
    computed: {
        selected: {
            get() {
                return this.$store.getters['visa/visa']
            },
            set(v) {
                this.$store.commit('visa/visa', { visa: v })
            }
        }
    },
    data: () => ({
        visas: ['bpiguet', 'cpiguet', 'crobinson', 'bmazat']
    })
}
</script>

<style lang="stylus">
.pad-visa-selector {
    max-width: 150px;

    .v-select__selection {
        font-weight: bold;
        color: white;
    }
}
</style>
